import { supportChatListeners } from "./supportChatListeners";

export const attachSocketEvents = (socket, dispatch) => {
  supportChatListeners(socket, dispatch);
};
